<template>
	<div class="blume">
		<!-- tooltips für Blütenblätter als Dialog umsetzen, daten ziehen, an die Daten angepasste beschreibung/erläuterung -->
		<v-dialog v-model="blumeDialog" eager persistent max-width="1000">
			<template v-slot:activator="{ on: dialog, attrs }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on: tooltip }">
						<canvas v-bind:id="canvasid1" width="80" height="80" v-bind="attrs" v-on="{...tooltip, ...dialog}">Ihr Browser unterst&uuml;tzt das Element <code>canvas</code> nicht.</canvas>
					</template>
					<span>Bewertung des Verfahrens. F&uuml;r n&auml;here Informationen bitte klicken.</span>
				</v-tooltip>
			</template>
			<v-card>
				<v-card-title class="headline">Bewertung des Verfahrens</v-card-title>
				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="2">
							</v-col>	
							<v-col cols="6">
								<p style="color:#CC8244;" class="erlaeuterung"><strong>{{verfahrensbewertung['fundierung']['titel']}}</strong>. {{verfahrensbewertung['fundierung']['beschreibung']}}</p>
								<p class="beurteilung">Beurteilung: {{verfahrensbewertung['fundierung']['bewertung'][bewertungen[1]]}}</p>									
							</v-col>
							<v-col>
							</v-col>														
						</v-row>
						<v-row>
							<v-col align-self="center">
								<p style="color:#297A7A;" class="erlaeuterung"><strong>{{verfahrensbewertung['verfuegbarkeit']['titel']}}</strong>. {{verfahrensbewertung['verfuegbarkeit']['beschreibung']}}</p>
								<p class="beurteilung">Beurteilung: {{verfahrensbewertung['verfuegbarkeit']['bewertung'][bewertungen[2]]}}</p>		
							</v-col>
							<v-col cols="3">
								<p style="text-align:center;"><canvas v-bind:id="canvasid2" width="160" height="160">Ihr Browser unterst&uuml;tzt das Element <code>canvas</code> nicht.</canvas></p>
							</v-col>
							<v-col>
								<p style="color:#CC4444;" class="erlaeuterung"><strong>{{verfahrensbewertung['relevanz']['titel']}}</strong>. {{verfahrensbewertung['relevanz']['beschreibung']}}</p>
								<p class="beurteilung">Beurteilung: {{verfahrensbewertung['relevanz']['bewertung'][bewertungen[0]]}}</p>
							</v-col>														
						</v-row>
						<v-row>
							<v-col cols="6">
								<p style="color:#37A337;" class="erlaeuterung"><strong>{{verfahrensbewertung['aufwand']['titel']}}</strong>. {{verfahrensbewertung['aufwand']['beschreibung']}}</p>
								<p class="beurteilung">Beurteilung: {{verfahrensbewertung['aufwand']['bewertung'][bewertungen[3]]}}</p>								
							</v-col>
							<v-col align-self="center">
								<p style="color:#ee6f57;" class="erlaeuterung"><strong>{{verfahrensbewertung['hilfestellung']['titel']}}</strong>. {{verfahrensbewertung['hilfestellung']['beschreibung']}}</p>
								<p class="beurteilung">Beurteilung: {{verfahrensbewertung['hilfestellung']['bewertung'][bewertungen[4]]}}</p>	
							</v-col>														
						</v-row>
					</v-container>
				</v-card-text>
				<v-card-actions>
				<v-spacer></v-spacer>
					<v-btn color="primary" text @click="blumeDialog=false">Schließen</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
	// import axios from 'axios';
	export default {
		name: 'Blume',
		props: {
			kontext: {
				type: String,
				required: true
			},
			verfahrenid: {
				type: String,
				required: true
			},
			verfahrenBewertung: {
				type: Array,
				required: false,
				default: Array
			}			
		},
		data() {
			return {
				verfahrenAuswahl: null,
				blumeDialog: false,
				bewertungen: [],
				canvasid1: String,
				canvasid2: String,
				xo: 5,
				yo: 5,
				rand: 5,
				verfahrensbewertung: {
					"relevanz": {
						titel: "Relevanz",
						beschreibung: "Anzahl spezifischer Items bzw. Ausrichtung der Maßnahme.",
						bewertung: {
							1: "Dieses Verfahren bezieht sich auf lediglich eine Facette der Arbeitsdichte, die undifferenziert abgebildet ist.",
							2: "Dieses Verfahren bezieht sich auf wenige Facetten der Arbeitsdichte bzw. einzelne undifferenziert abgebildete Facetten.",
							3: "Dieses Verfahren bezieht sich auf einige Facetten der Arbeitsdichte bzw. einzelne differenziert abgebildete Facetten.",
							4: "Dieses Verfahren bezieht sich auf mehrere Facetten der Arbeitsdichte enthalten bzw. einzelne differenziert abgebildete Facetten.",
							5: "Dieses Verfahren bezieht sich auf alle Facetten der Arbeitsdichte bzw. einzelne differenziert abgebildete Facetten."
						}		
					},
					"fundierung": {
						titel: "Fundierung",
						beschreibung: "Validierung und Evaluation Empfehlung durch Institution wie etwa BAuA.",
						bewertung: {
							1: "Die theoretische und wissenschaftliche Fundierung dieses Verfahrens ist unklar.",
							2: "Die theoretische und wissenschaftliche Fundierung dieses Verfahrens gering.",
							3: "Dieses Verfahren wird durch Institutionen wie BAuA oder Berufsgenossenschaften empfohlen.",
							4: "Dieses Verfahren erfüllt wissenschaftliche Gütekriterien teilweise (Validierung und Evaluation).",
							5: "Dieses Verfahren erfüllt wissenschaftliche Gütekriterien (Validierung und Evaluation)."
						}		
					},
					"verfuegbarkeit": {
						titel: "Verfuegbarkeit",
						beschreibung: "Zugang zum Verfahren, kostenpflichtige Journals etc.",
						bewertung: {
							1: "Der Zugang zu diesem Verfahren ist unklar.",
							2: "Der Zugang zu diesem Verfahren ist sehr umständlich.",
							3: "Der Zugang zu diesem Verfahren ist umständlich.",
							4: "Der Zugang zu diesem Verfahren erfolgt nach einfacher Registrierung bzw. Zahlung.",
							5: "Der Zugang zu diesem Verfahren erfolgt frei und unmittelbar."
						}		
					},	
					"aufwand": {
						titel: "Aufwand",
						beschreibung: "Vorbereitungs- und Durchführungszeiten.",
						bewertung: {
							1: "Dieses Verfahren hat hohe oder unklare Vorbereitungs- und Durchführungszeiten.",
							2: "Dieses Verfahren hat hohe Vorbereitungs- und Durchführungszeiten.",
							3: "Dieses Verfahren hat mittlere Vorbereitungs- und Durchführungszeiten.",
							4: "Dieses Verfahren hat relativ geringe Vorbereitungs- und Durchführungszeiten.",
							5: "Dieses Verfahren hat geringe Vorbereitungs- und Durchführungszeiten."
						}		
					},	
					"hilfestellung": {
						titel: "Hilfestellung",
						beschreibung: "Testmanual oder Handlungsanweisung, Rückmeldung an die Beschäftigten.",
						bewertung: {
							1: "Dieses Verfahren enthält keine Hinweise zur Durchführung.",
							2: "Dieses Verfahren enthält kaum Hinweise zur Durchführung.",
							3: "Dieses Verfahren enthält einige Hinweise zur Durchführung.",
							4: "Dieses Verfahren enthält Materialien zur Durchführung.",
							5: "Dieses Verfahren enthält umfassende Materialien zur Durchführung."
						}		
					}										
				}
			}
		},
		created() {
			this.canvasid1 = this.kontext + '_blume1_' + this.verfahrenid;
			this.canvasid2 = this.kontext + '_blume2_' + this.verfahrenid;
		},
		mounted() {
			// console.log(this.verfahrenid);
			// this.bewertungenHolen(this.verfahrenid);
			this.bewertungenNachschlagen(this.verfahrenid);
			// this.verfahrenAuswahl = JSON.parse(localStorage.getItem('verfahrenAuswahl'));
			// console.log(this.verfahrenAuswahl);
		},
		methods: {
			randomInteger: function(min, max) {
				if (min==null && max==null)
				return 0;
				if (max == null) {
					max = min;
					min = 0;
				}
				return min + Math.floor(Math.random() * (max - min + 1));
			},
			// async bewertungenHolen(verfahrenid) {
			// 	console.log('Blume: Bewertungen holen');
			// 	axios.get('https://www.arbeitsverdichtung.de/api/bewertung/' + verfahrenid)
			// 	.then(response => {
			// 		this.bewertungen = response.data;
			// 		// console.log("blume.vue: this.verfahrenBewertung");
			// 		// console.log(this.bewertungen);
			// 		this.blumeZeichnen(this.canvasid1);
			// 		this.blumeZeichnen(this.canvasid2);
			// 	})
			// 	.catch(error => {
			// 		this.errorMessage = error.message;
			// 		console.error("There was an error!", error);
			// 	});
			// },
			bewertungenNachschlagen(verfahrenid) {
				/* Bewertungen aus den übergebenen props holen */
				// console.log(this.verfahrenBewertung);
				// console.log(this.verfahrenBewertung.length);
				if (this.verfahrenBewertung.length === 5) {
					// console.log('Blume: Bewertungen aus Websspeicher holen');
					this.bewertungen = this.verfahrenBewertung;
				/* Bewertungen aus dem Webspeicher holen */
				} else {
					// console.log('Blume: Bewertungen aus Websspeicher holen');
					var gespeicherteVerfahrenAuswahl = JSON.parse(localStorage.getItem('verfahrenAuswahl'));
					// var index = this.verfahrenAuswahl.findIndex(verfahren => verfahren.verfahrenid == verfahrenid);
					var index = gespeicherteVerfahrenAuswahl.map(function(verfahren) { return verfahren.verfahrenid; }).indexOf(verfahrenid);
					this.bewertungen.push(parseInt(gespeicherteVerfahrenAuswahl[index].bewertung1));
					this.bewertungen.push(parseInt(gespeicherteVerfahrenAuswahl[index].bewertung2));
					this.bewertungen.push(parseInt(gespeicherteVerfahrenAuswahl[index].bewertung3));
					this.bewertungen.push(parseInt(gespeicherteVerfahrenAuswahl[index].bewertung4));
					this.bewertungen.push(parseInt(gespeicherteVerfahrenAuswahl[index].bewertung5));

					this.blumeZeichnen(this.canvasid1, this.canvasid2);
					this.blumeZeichnen(this.canvasid2);
				}
			},
			blumeZeichnen: function(cid) {

				var bewertungen = this.bewertungen;

				// console.log('Blume: bewertungen');
				// console.log(bewertungen);

				if ( bewertungen.every( bewertung  => Number.isInteger(bewertung) ) ) {

					var canvas = document.getElementById(cid);
					var ctx = canvas.getContext('2d');

					// Blume leeren
					ctx.clearRect(0, 0, canvas.width, canvas.height);

					// Dimensionen der Blume
					if (canvas.width > window.innerWidth) canvas.width = window.innerWidth;
					var blumenmitteX = canvas.width/2;
					var blumenmitteY = canvas.height/2;

					// Rahmen zeichnen
					// ctx.lineWidth = 1;
					// ctx.strokeStyle = '#000000';
					// ctx.strokeRect(0, 0, canvas.height, canvas.width);

					// Einstellugen
					var farben = ['#CC4444','#CC8244','#297A7A','#37A337','#ee6f57'];
					var abweichungsfaktor = (canvas.width / 80 ) * 5;
					var skalierungsfaktor = (canvas.width / 80 ) * 2;
					var winkel = [36, 108, 180, 252, 324];

					// Berechnung der Koordinaten der Mittelpunkte und Randpunkte (Bogenmaß im Einheitskreis)
					var mittelpunkteX = [];
					var mittelpunkteY = [];
					var randpunkteX = [];
					var randpunkteY = [];
					for (var i = 0; i <= 4; i++) {
						var bogenmass = ( winkel[i] / 360 ) * 2 * Math.PI;
						mittelpunkteX[i] = blumenmitteX + Math.cos(bogenmass) * bewertungen[i] * abweichungsfaktor;
						mittelpunkteY[i] = blumenmitteY - Math.sin(bogenmass) * bewertungen[i] * abweichungsfaktor;
						randpunkteX[i]   = blumenmitteX + Math.cos(bogenmass) * bewertungen[i] * abweichungsfaktor * 0.5;
						randpunkteY[i]   = blumenmitteY - Math.sin(bogenmass) * bewertungen[i] * abweichungsfaktor * 0.5;
					}

					// Blütenstengel, die von der Mitte ausgehen
					for (var j = 0; j <= 4; j++) {
						ctx.lineWidth = (canvas.width / 80 ) * bewertungen[j] * 0.75;
						var gradient = ctx.createLinearGradient(blumenmitteX, blumenmitteY, randpunkteX[j], randpunkteY[j]);
						gradient.addColorStop(0, '#ffffff');
						gradient.addColorStop(1, farben[j]);
						ctx.strokeStyle=gradient;
						ctx.beginPath();
						ctx.moveTo(blumenmitteX, blumenmitteY);
						ctx.lineTo(randpunkteX[j], randpunkteY[j]);
						ctx.closePath();
						ctx.stroke();
					}

					// Punkt in der Mitte
					ctx.lineWidth = 1;
					ctx.strokeStyle = '#868686';
					ctx.fillStyle = '#ffffff';
					ctx.beginPath();
					ctx.arc(blumenmitteX, blumenmitteY, skalierungsfaktor, 0, Math.PI * 2, true);
					ctx.closePath();
					ctx.fill();
					ctx.stroke();

					// Blüten zeichnen
					for (var k = 0; k <= 4; k++) {
						// Blütenblatt
						ctx.lineWidth = 1;
						ctx.strokeStyle = farben[k];
						ctx.fillStyle = farben[k];
						ctx.beginPath();
						ctx.arc(mittelpunkteX[k], mittelpunkteY[k], (bewertungen[k]+1)*skalierungsfaktor, 0, Math.PI * 2, true);
						ctx.closePath();
						ctx.fill();
						ctx.stroke();
						// weißer Rand
						ctx.strokeStyle = '#ffffff';
						ctx.beginPath();
						ctx.arc(mittelpunkteX[k], mittelpunkteY[k], ( (bewertungen[k]+1) * skalierungsfaktor ) -1, 0, Math.PI * 2, true);
						ctx.closePath();
						ctx.stroke();
					}
				} else {
					console.log('Es liegen nicht alle Integer-Werte vor!')
				}
			}
		}
	}
</script>
<style scoped>
	.blume {
		margin: 0;
		padding: 0;
	}
	.erlaeuterung {
		font-size: 1.25em;
		text-align: center;
	}
	.beurteilung {
		font-size: 1.00em;
		text-align: center;
	}
</style>
